import styled from "styled-components";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { PaddedContainer } from "../../styles/styles";

const TOP_SLIDE_HEIGHT = "400px";

const TopCarouselLayer = styled.div`
  display: flex;
  gap: 12px;
  overflow: hidden;
  padding: 12px 0 16px;
`;

const TopSlide = styled.div`
  flex: 0 0 min(280px, calc(100vw - 88px));
`;

const LayerDivider = styled.div`
  width: 100%;
  border-top: 1px solid var(--grey200);
  margin: 4px 0 12px;
`;

const ThumbnailCarouselLayer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  padding-bottom: 4px;
`;

const ThumbnailSlot = styled.div`
  flex: 0 0 auto;
`;

const TOP_SLIDE_COUNT = 3;
const THUMBNAIL_COUNT = 8;

export const MediaImagesCarouselSkeleton = () => {
  return (
    <PaddedContainer $py={"0px"} $px={"16px"}>
      <TopCarouselLayer>
        {Array.from({ length: TOP_SLIDE_COUNT }).map((_, index) => (
          <TopSlide key={`media-carousel-top-skeleton-${index}`}>
            <FixaSkeleton height={TOP_SLIDE_HEIGHT} width={"100%"} />
          </TopSlide>
        ))}
      </TopCarouselLayer>

      <LayerDivider />

      <ThumbnailCarouselLayer>
        {Array.from({ length: THUMBNAIL_COUNT }).map((_, index) => (
          <ThumbnailSlot key={`media-carousel-thumbnail-skeleton-${index}`}>
            <FixaSkeleton height={"52px"} width={"52px"} />
          </ThumbnailSlot>
        ))}
      </ThumbnailCarouselLayer>
    </PaddedContainer>
  );
};
